<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div *ngIf="featureFlagManager.getFlag$(DynamicFlagTypes.PROJECT_SCHEDULE_ENABLED)">
	<dialog-titlebar [title]="strings.PROJECT_SCHEDULE_TITLE"></dialog-titlebar>

	<mat-tab-group mat-dialog-content>
		<mat-tab [label]="strings.EXTERNAL_SCHEDULE_TITLE">
			<app-external-schedule [data]="data" [hostDialogRef]="dialogRef"></app-external-schedule>
		</mat-tab>
		<mat-tab [label]="strings.WBS_MENU_ITEM">
			<app-wbs-sync [data]="data" [hostDialogRef]="dialogRef"></app-wbs-sync>
		</mat-tab>

		<!-- add more tabs here -->
	</mat-tab-group>
</div>
